import swal from 'sweetalert2'
import moment from 'moment'
import momentTZ from 'moment-timezone'
import store from './store/store'
import i18n from './locales/i18n'
import { find, pick, forIn, head, chain } from 'lodash'

export function versaoGitFiltrada (versao) {
  return versao && typeof versao === 'string' && versao.replace(/(\r\n|\n|\r)/gm, '').match(/^v\d+.\d+.\d+-?\w*$/) ? versao : 'v0.0.0'
}

export function generateObjectId () {
  var timestamp = (new Date().getTime() / 1000 | 0).toString(16)
  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
    return (Math.random() * 16 | 0).toString(16)
  }).toLowerCase()
}

export function padZeroNumber (v) {
  return parseInt(v.toFixed(0)) < 10.0 ? '0' + v.toFixed(0) : v.toFixed(0)
}

export function floatToHoursMinsString (number) {
  const hours = Math.floor(number)
  const minutes = (number % 1) * 60
  return `${padZeroNumber(hours)}:${padZeroNumber(minutes)}`
}

export function floatToHoursMins (number) {
  const hours = Math.floor(number)
  const minutes = (number % 1) * 60
  return {hours, minutes, float: number}
}

export function inputTimeTofloat (time) {
  const hours = time.slice(0, 2)
  const minutes = time.slice(3, 5)
  return hoursMinsToFloat(hours, minutes)
}

export function hoursMinsToFloat (hours, minutes) {
  return parseInt(hours) + (parseInt(minutes) / 60)
}

export function datetimeToTimeString (datetime) { return datetime.substr(11, 5) }

export async function handleResponse (promise) {
  let response
  try {
    response = await promise
    if (response.body.success || response.body.created) {
      swal({
        type: 'success',
        text: response.body.success || i18n.t('utils.handleResponse.textoPadraoSucesso')
      })
    } else if (response.body.info) {
      swal({
        type: 'info',
        text: response.body.info
      })
    }
  } catch (error) {
    response = error
    if (error.body.error) {
      swal({
        type: 'error',
        text: error.body.error || i18n.t('utils.handleResponse.textoPadraoFalha')
      })
    }
  }
  return response
}

export function getWithDotNotation (model, column, character = '.') {
  // access with string the attributes of objects with dot notation... e.g: {a: {b: true}} = parseColumn(obj, 'a.b')
  return column.split(character).reduce((o, i) => o[i], model)
}

export function formatDateToSend (date) {
  if (moment.isMoment(date)) {
    return date.format('YYYY-MM-DDTHH:mm:ss')
  }
  return moment(date).format('YYYY-MM-DDTHH:mm:ss')
}

export function prettyDate (momentDate) {
  return momentDate.format('DD/MM/YYYY')
}

export function prettyDateTime (momentDate, seconds = true) {
  return seconds ? momentDate.format('DD/MM/YYYY - HH:mm:ss') : momentDate.format('DD/MM/YYYY - HH:mm')
}

export function isInputTimeValid (time, dots = false) {
  let regex
  if (dots) {
    if (time.length !== 5) { return false }
    regex = /^([0-9]|0[0-9]|1?[0-9]|2[0-3]):[0-5]?[0-9]$/
  } else {
    if (time.length !== 4) { return false }
    regex = /^([0-9]|0[0-9]|1?[0-9]|2[0-3])[0-5]?[0-9]$/
  }
  return regex.test(time)
}

export function inputTimeToMoment (time) {
  return moment().set({hour: time.slice(0, 2), minutes: time.slice(3, 5)})
}

export function resetStateToDefault (state, defaultState) {
  Object.assign(state, defaultState)
}

export function removeDuplicatesArray (arrayOfObjects, key) {
  let tester = []
  let result = []
  arrayOfObjects.forEach(el => {
    if (tester.indexOf(el[key]) === -1) {
      tester.push(el[key])
      result.push(el)
    }
  })
  return result
}

export function getFirstHour (date) {
  if (moment.isMoment(date)) {
    return date.clone().startOf('day')
  }
  return moment(date).startOf('day').toDate()
}

export function getLastHour (date) {
  if (moment.isMoment(date)) {
    return date.endOf('day')
  }
  return moment(date).endOf('day').toDate()
}

export function hasPermission (conditions, userRoles) {
  let isValid = false

  const verifyPermission = (spec, roles) => {
    return (typeof find(roles, pick(spec, 'module', 'action')) !== 'undefined')
  }

  if (!userRoles) {
    userRoles = store.getters.getUserInfo.roles
  }

  const userRolesNames = userRoles.map(r => r.name)

  if (conditions.module) {
    if (conditions.filter) {
      const filters = conditions.filter

      for (let i = 0; i < filters.length; i++) {
        conditions.filter = filters[i]

        isValid = isValid || verifyPermission(conditions, userRoles)
      }
    } else {
      isValid = verifyPermission(conditions, userRoles)
    }
  } else if (conditions.any) {
    for (let role of conditions.any) {
      isValid = userRolesNames.includes(role)
      break
    }
  } else if (conditions.multiple) {
    let rolesUserHasThatIsRequired = []
    for (let role of conditions.any) {
      if (userRolesNames.includes(role)) {
        rolesUserHasThatIsRequired.push(role)
      }
    }
    isValid = rolesUserHasThatIsRequired.length === conditions.multiple.length
  }
  return isValid
}

export function vuexMapDefaultsGetters (stateObject) {
  let result = {}
  forIn(stateObject, (value, key) => {
    result[key] = (state) => state[key]
  })
  return result
}

export function vuexMapDefaultsMutations (stateObject) {
  let result = {}
  forIn(stateObject, (value, key) => {
    result[key] = (state, payload) => {
      state[key] = payload
    }
  })
  return result
}

export function vuexMapDefaultsActions (stateObject) {
  let result = {}
  forIn(stateObject, (value, key) => {
    result[key] = ({commit}, payload) => {
      commit(key, payload)
    }
  })
  return result
}

export function chunkList (list, chunkSize) {
  const result = list.reduce((ar, it, i) => {
    const ix = Math.floor(i / chunkSize)
    if (!ar[ix]) {
      ar[ix] = []
    }
    ar[ix].push(it)
    return ar
  }, [])
  return result
}

export function promiseTimeout (ms, promise) {
  // Create a promise that rejects in <ms> milliseconds
  let timeout = new Promise((resolve, reject) => {
    let id = setTimeout(() => {
      clearTimeout(id)
      reject('timeout')
    }, ms)
  })

  // Returns a race between our timeout and the passed in promise
  return Promise.race([
    promise,
    timeout
  ])
}

export function mostCommon (array) {
  return head(_(array)
    .countBy()
    .entries()
    .maxBy('[1]'))
}

export function rangeDates (startDate, endDate) {
  startDate = moment.isMoment(startDate) ? startDate.toDate() : startDate
  endDate = moment.isMoment(endDate) ? endDate.toDate() : endDate

  let dates = []
  let currentDate = startDate
  let addDays = function (days) {
    let date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  while (currentDate <= endDate) {
    dates.push(currentDate)
    currentDate = addDays.call(currentDate, 1)
  }
  return dates.map(i => moment(i))
}

export function groupBy (data, key) {
  return chain(data)
    .groupBy(i => getWithDotNotation(i, key))
    .toPairs()
    .value()
}

export function range (lowEnd, highEnd) {
  let list = []
  for (let i = lowEnd; i <= highEnd; i++) {
    list.push(i)
  }
  return list
}

export function copiarObjetoProfundamente (obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function deepFreeze (o) {
  Object.freeze(o)
  if (o === undefined) {
    return o
  }
  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop])
    }
  })
  return o
}

export function freezeObjects (list) {
  list.forEach(i => {
    deepFreeze(i)
  })
  return list
}

export function parseColorApontamento (apont) {
  let result = 'btn-default'
  if (!apont) { return }
  if (apont.includes('100') || apont.includes('B') || apont.includes('_b')) {
    result = 'btn-warning'
  } else if (apont.includes('C') || apont.includes('Spec') || apont.includes('_c')) {
    result = 'btn-info'
  }
  return result
}

export function orderEmployees (listEmployees, by = 'name', reversed = false) {
  let final = [...listEmployees]
  if (by === 'name') {
    final.sort(function order (a, b) {
      if (a.name < b.name) {
        return -1
      } else if (a.name > b.name) {
        return 1
      }
      return 0
    })
  } else if (by === 'code') {
    final.sort(function order (a, b) {
      return parseInt(a.code) - parseInt(b.code)
    })
  }
  if (reversed) {
    final.reverse()
  }
  return final
}

export function joinBaseDateBaseTime (baseDate, baseTime) {
  // Use when do you have a date without time and you have a date with time
  // baseDate = Date(2018, 5, 5)
  // baseTime = Date(0, 0, 0, 15, 15)
  // returns Date(2018, 5, 5, 15, 15)
  let date = moment(baseDate)
  let time = moment(baseTime)
  date.add(time.date() - 1, 'days')
  date.set({
    hour: time.hours(),
    minute: time.minute()
  })
  return date
}

export function includesSearch (a, b) {
  return noSpecialChar(a.toLowerCase()).includes(noSpecialChar(b.toLowerCase()))
}

export function noSpecialChar (text) {
  text = text.toLowerCase()
  text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
  text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
  text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
  text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
  text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
  text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
  return text
}

export function validateCnpj (cnpj) {
  if (cnpj.split('').filter(i => !isNaN(i)).length !== 14) {
    return false
  }

  return Boolean(cnpj.match(/[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2}/))
}

export async function openElementInFullscreen (elem, onCloseFullScreen) {
  if (elem.requestFullscreen) {
    await elem.requestFullscreen()
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    await elem.mozRequestFullScreen()
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    await elem.webkitRequestFullscreen()
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    await elem.msRequestFullscreen()
  }

  if (document.addEventListener) {
    document.addEventListener('webkitfullscreenchange', exitHandler, false)
    document.addEventListener('mozfullscreenchange', exitHandler, false)
    document.addEventListener('fullscreenchange', exitHandler, false)
    document.addEventListener('MSFullscreenChange', exitHandler, false)
  }

  function exitHandler () {
    if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement !== null) {
      onCloseFullScreen()
    }
  }
}

export function closeFullscreen () {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

export function isostringToMoment (str) {
  return moment(str, 'YYYY-MM-DDTHH:mm:ss')
}

export function dateRangeArray (momentStartDate, momentEndDate) {
  const resultArray = [momentStartDate.clone()]
  const deltaInDays = parseInt(moment.duration(momentEndDate.diff(momentStartDate)).asDays())
  let aux = momentStartDate.clone()
  for (let i = 0; i < deltaInDays; i++) {
    aux.add(1, 'days')
    resultArray.push(moment(aux))
  }
  return resultArray
}

export function round (num, scale) {
  if (!('' + num).includes('e')) {
    return +(Math.round(num + 'e+' + scale) + 'e-' + scale)
  } else {
    let arr = ('' + num).split('e')
    let sig = ''
    if (+arr[1] + scale > 0) {
      sig = '+'
    }
    return +(Math.round(+arr[0] + 'e' + sig + (+arr[1] + scale)) + 'e-' + scale)
  }
}

export function getUserInfo (persistentKey) {
  try {
    return JSON.parse(window.localStorage.getItem(persistentKey)).userInfo
  } catch (e) {
    console.warn('error on getting persisted user info')
    console.warn(e)
    return {}
  }
}

export function getEmployeeTimesheetDateRange (day, closingDate) {
  // Get the range of dates on employee timesheet

  let dateStart

  day = moment.isMoment(day) ? day : moment(day)

  // start
  if (day.date() < closingDate) {
    dateStart = day.clone().subtract(1, 'month')
    dateStart = dateStart.set('date', closingDate)
  } else {
    dateStart = day.clone().set('date', closingDate)
    dateStart = getFirstHour(dateStart)
  }

  // end
  const endDate = dateStart.clone().add(1, 'months')
  const dateEnd = getLastHour(endDate).subtract(1, 'days')

  return {startDate: dateStart, endDate: dateEnd}
}

export function getComManInfo (persistentKey) {
  try {
    return JSON.parse(window.localStorage.getItem(persistentKey)).accessData.compMan.id
  } catch (e) {
    return null
  }
}

export function isMobile () {
  if (navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true
  } else {
    return false
  }
}

export function inseriItemNoLocalStorage (key, item) {
  localStorage.setItem(key, JSON.stringify(item))
}

export function retornaItemDoLocalStorage (key) {
  return JSON.parse(localStorage.getItem(key)) || null
}

export function formataStringParaCaptalize (string) {
  if (!string) return
  const strArr = string.trim().toLowerCase().split(' ')
  const arrSemValoresFalsy = strArr.filter(letter => letter)

  const result = arrSemValoresFalsy.reduce((acc, str, index) => {
    if (index === 0) {
      acc = str[0].toUpperCase() + str.slice(1)
    } else {
      acc = acc + ' ' + str[0].toUpperCase() + str.slice(1)
    }

    return acc
  }, '')
  return result
}

export const converterHorarioUtcParaComTimezone = (data, timeZone) => {
  const novaData = momentTZ.utc(data)
  const novaDataConvertida = novaData.clone().tz(timeZone).format()
  const dataSemOffSet = removerTimezoneOffSet(novaDataConvertida)
  return new Date(dataSemOffSet)
}

export const removerTimezoneOffSet = (data) => {
  if (!data) return
  const dataUTC = momentTZ.utc(data)
  const dataParseada = momentTZ.parseZone(dataUTC).format()
  const indexTimeZone = dataParseada.length - 6

  return dataParseada.slice(0, indexTimeZone)
}

export const tratarErroDoBackParaString = (erro) => {
  const erroEmArray = Array.isArray(erro)

  if (!erroEmArray) return erro

  const erros = erro.reduce((acc, erro, index, array) => {
    if (array.length > 1) {
      const ehOUltimoErroDoArray = index === array.length - 1
      acc += ehOUltimoErroDoArray ? erro.msg : erro.msg + ', '
    } else {
      acc += erro.msg
    }
    return acc
  }, '')
  return erros
}

const montarMensagemDeErroServidor = () => {
  return i18n.t('utils.montarMensagemDeErroServidor')
}

const montarCodigoErroServidor = (entidade, rota, status) => {
  return `cod. ${entidade}${rota}${status}`
}

export const informarErroServidor = {
  montarMensagemDeErroServidor,
  montarCodigoErroServidor
}

export function modalDeErro (mensagemDeErro, tituloDaMensagem = null) {
  if (!mensagemDeErro) return

  swal({
    type: 'error',
    text: mensagemDeErro,
    title: tituloDaMensagem || i18n.t('comum.mensagem.erro')
  })
}
